import * as UserEndpointConstants from './user'
import * as PaymentEndpointConstants from './payments'
export const userEndpointConstants = UserEndpointConstants
export const paymentEndpointConstants = PaymentEndpointConstants
